module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/aneta-dunn-079ddd67a32b2781c46d7800030ebb4c.png";